import React, { useState } from "react";
import { uploadFileToAzure } from "../../services/azure";
window.Buffer = window.Buffer || require("buffer").Buffer;
const AzureImageUploader = () => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    const result = await uploadFileToAzure(selectedFile.name, selectedFile, { action: "profile" });
    console.log(result);
  };

  return (
    <div>
      <input type="file" onChange={handleFileChange} />
      <button onClick={handleUpload}>Upload Image</button>
    </div>
  );
};

export default AzureImageUploader;
